import React from 'react';

const Logo = ({ className = '', size = 'default' }) => {
  const sizes = {
    small: { width: 150, height: 40 },
    default: { width: 180, height: 48 },
    large: { width: 240, height: 64 }
  };

  const { width, height } = sizes[size] || sizes.default;

  return (
    <svg 
      className={className}
      width={width} 
      height={height} 
      viewBox="0 0 400 80" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* House Icon with AI symbols */}
      <defs>
        <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#632cf1" />
          <stop offset="50%" stopColor="#5f1dec" />
          <stop offset="100%" stopColor="#004aad" />
        </linearGradient>
        <linearGradient id="purpleGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#632cf1" />
          <stop offset="100%" stopColor="#9c6bff" />
        </linearGradient>
      </defs>
      
      {/* House circle background */}
      <circle cx="35" cy="40" r="32" fill="url(#logoGradient)" />
      
      {/* House shape */}
      <path 
        d="M35 18L15 35V55C15 57 16.5 58.5 18.5 58.5H51.5C53.5 58.5 55 57 55 55V35L35 18Z" 
        fill="white" 
        fillOpacity="0.2"
      />
      
      {/* AI icon inside house */}
      <rect x="24" y="38" width="8" height="8" rx="1.5" fill="white" />
      <rect x="24" y="48" width="8" height="8" rx="1.5" fill="white" />
      <circle cx="42" cy="42" r="4" fill="white" />
      <path d="M38 52L42 48L46 52" stroke="white" strokeWidth="2" strokeLinecap="round" />
      
      {/* Text: Deal */}
      <text x="78" y="52" fontFamily="DM Sans, sans-serif" fontSize="32" fontWeight="700" fill="#1a1a2e">Deal</text>
      
      {/* Text: TO with keyhole */}
      <text x="148" y="52" fontFamily="DM Sans, sans-serif" fontSize="32" fontWeight="700" fill="url(#purpleGradient)">T</text>
      
      {/* Keyhole O */}
      <circle cx="185" cy="40" r="16" fill="url(#purpleGradient)" />
      <circle cx="185" cy="36" r="5" fill="white" />
      <path d="M182 38V50H188V38" fill="white" />
      
      {/* Text: Close */}
      <text x="210" y="52" fontFamily="DM Sans, sans-serif" fontSize="32" fontWeight="700" fill="#1a1a2e">Close</text>
      
      {/* Text: AI */}
      <text x="298" y="52" fontFamily="DM Sans, sans-serif" fontSize="32" fontWeight="700" fill="url(#purpleGradient)">AI</text>
      
      {/* Sparkle */}
      <path 
        d="M345 15L347 22L354 24L347 26L345 33L343 26L336 24L343 22L345 15Z" 
        fill="url(#purpleGradient)"
      />
      <path 
        d="M358 8L359 12L363 13L359 14L358 18L357 14L353 13L357 12L358 8Z" 
        fill="url(#purpleGradient)"
        opacity="0.6"
      />
    </svg>
  );
};

export default Logo;
